export default {
  install(app) {
    app.directive('visible', (el, binding) => {
      el.style.visibility = binding.value ? 'visible' : 'hidden';
    });
  },
};
